// removed by extract-text-webpack-plugin
module.exports = {"Divider":"_19SjP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hotel/HotelTuple/TupleDivider/TupleDivider.scss
// module id = 897
// module chunks = 0